import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { registerServiceWorker } from "./engine/swsink";
import { registerWebMcp } from "./webmcp";
import "./styles.css";

// Register WebMCP for browser AI agents and Service Worker for streaming downloads.
void registerServiceWorker();
registerWebMcp();

const rootEl = document.getElementById("root")!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Static routes are pre-rendered at build time (scripts/prerender.mjs). Hydrate when the HTML on the
// page was rendered for this exact route; otherwise (SPA fallback for /d/…) render from scratch.
if (rootEl.dataset["route"] === window.location.pathname && rootEl.childElementCount > 0) {
  hydrateRoot(rootEl, app);
} else {
  rootEl.replaceChildren();
  createRoot(rootEl).render(app);
}
document.documentElement.classList.remove("ls-nohydrate");
